import {
    ChallengeFailureHandler,
    LoginErrorHandler,
    LoginFailureEvent,
    useAuth,
    useEventHandlers,
    WorkflowChallengeFailedEvent,
} from '@turiya/login-component';
import React, { useEffect } from 'react';
import { NotificationManager } from 'react-notifications';

export const ContextHandler: React.FC = () => {
    const { signOut } = useAuth();
    const { onLoginError, onChallengeFailure } = useEventHandlers();

    useEffect(() => {
        onLoginError(loginFailureHandlers.onLoginError!(signOut));
        onChallengeFailure(loginFailureHandlers.onChallengeFailure!);
    }, [onChallengeFailure, onLoginError, signOut]);

    return <></>;
};

const loginFailureHandlers: {
    onLoginError: (signOut: () => Promise<void>) => LoginErrorHandler;
    onChallengeFailure: ChallengeFailureHandler;
} = {
    onLoginError:
        () =>
        async (error: LoginFailureEvent): Promise<void> => {
            const errorData = error.data as { details?: { body: { statusMessage: string } } };

            try {
                if (errorData?.details?.body?.statusMessage) {
                    const message = errorData.details.body.statusMessage;
                    try {
                        NotificationManager.error(message || 'Invalid Username or Password');
                    } catch {
                        NotificationManager.error('Invalid Username or Password');
                    }
                } else {
                    NotificationManager.error('Invalid Username or Password');
                }
            } catch (e) {
                NotificationManager.error('Invalid Username or Password');
            }
        },
    onChallengeFailure: async (e: WorkflowChallengeFailedEvent) => {
        NotificationManager.error(e.data.challengeFailureMessage);
    },
};
